import React, { useEffect, useContext, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Chart from "core/ui/charts/index";
import PrintableChart from "core/ui/charts/printable-chart";
import SessionContext from "SessionContext";

function InsightsPdfReport() {
  const session = useContext(SessionContext);

  const hasMounted = useRef(false);
  const [pageLoaded, setPageLoaded] = useState(false);

  const getData = window.sessionStorage.getItem('am:insight-report');
  let data = {};
  let todayDate = new Date().toLocaleDateString();

  const [disablePrint, setDisablePrint] = useState(true);

  function formatDateToYYYYMMDD() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}${month}${day}`;
  }

  useEffect(() => {
    if((session.crossfilterStore.count > 0) && !pageLoaded) {
      let report_name = `${data.company_name}_${data.audience_name}_${formatDateToYYYYMMDD()}`;
      let final_name = report_name.replace(/\s/g, '_');
      document.title = final_name;
      setDisablePrint(false);
      setPageLoaded(true);
      if(!hasMounted.current) {
        setTimeout(() => {
          window.print();
        }, 1200);
      }
    }
    
    return () => {
      if (hasMounted.current) {
        window.sessionStorage.removeItem('am:insight-report');
      }
      hasMounted.current = true;
    }
    // eslint-disable-next-line
  }, [session.crossfilterStore.count])

  if(!getData) {
    return (
      <div className="insight-pdf-wrapper">
        <div className="print-btn">
          <Link to={"/explorer"}>
            <button className="new-button">
              Back to Explorer
            </button>
          </Link>
        </div>
        
        <div className="insight-pdf-print">
          Could not load data to populate the report, please navigate back to explorer and try again.
        </div>
      </div>
    )
  }

  data = JSON.parse(getData);
  const insight_charts = session.crossfilterStore.widgets;
  const activeFilters = Object.entries(session.crossfilterStore.filters)
    .filter(([_, filters]) => !!filters)
    .map(([chart_id, _]) => chart_id);

  /* sort the uploads to be display last since they are the longest charts */
  const sorted_charts = insight_charts.sort((a, b) => a.includes('up_') - b.includes('up_'));
  
  return (
    <div className="insight-pdf-wrapper">
        <div className="print-btn">
          <button onClick={window.print} disabled={disablePrint}>Print Report</button>
          <Link to={"/explorer"}>
            <button className="new-button" disabled={disablePrint}>
              Back to Explorer
            </button>
          </Link>
        </div>
        
        <div id="report-wrapper" className="insight-pdf-print">
          <img src="/skins/default/am.svg" alt="Speedeon Audience Maker" id="company-logo"></img>
          <div className="title">Insights Report</div>
          <div className="header-info">
            <div><b>Prepared For</b>: {data.company_name}</div>
            <div><b>Audience</b>: {data.audience_name}</div>
            <div><b>Date</b>: {todayDate}</div>
          </div>

          <div className="criteria">
            <div><b>Selection Criteria</b>:</div>
            {activeFilters.map((chart_id) =>
              <Chart summarize chart_id={chart_id} key={chart_id} viewOnly />
            )}
            {!activeFilters.length && !data.is_complex && <div className="card p-3 mt-2">No Filters Applied.</div>}
            {data.is_complex && <div className="card p-3 mt-2">Complex Filters Applied.</div>}
          </div>
          <br />
          <div className="chart-list">
            <div><b>Insights</b>:</div>
            <div className="charts-flexbox">
              {sorted_charts.map((chart_id, i) => (
                <div className="chart-wrapper" key={chart_id}>
                  <PrintableChart
                    chart_id={chart_id}
                    crossfilter={false}
                    map={null}
                    viewOnly
                    expandedView
                    loaded={pageLoaded}
                    draggable={false}
                    onRemove={() => null}
                    onDragStart={() => null}
                    onDragEnd={() => null}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="insight-footer">Downloaded by {data.user_name} on {todayDate}</div>
        </div>
    </div>
  )
}

export default InsightsPdfReport;


